import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { HandleHitArea, HandleVisual } from "./styles";

export const Handle = ({
  domain: [min, max],
  handle: { id, value, percent },
  disabled = false,
  memory = false,
  getHandleProps
}) => {
  return (
    <Fragment>
      <HandleHitArea
        $percent={percent}
        $memory={memory}
        $disabled={disabled}
        {...getHandleProps(id)}
      />
      <HandleVisual
        role="slider"
        aria-valuemin={min}
        aria-valuemax={max}
        aria-valuenow={value}
        $percent={percent}
        $memory={memory}
        $disabled={disabled}
      />
    </Fragment>
  );
}

Handle.propTypes = {
  domain: PropTypes.array.isRequired,
  handle: PropTypes.shape({
    id: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    percent: PropTypes.number.isRequired
  }).isRequired,
  getHandleProps: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  memory: PropTypes.bool
};
